// This function add some leading zeros to first parameter is how many leading zeros
// second parameter the number we want to add plus one.
// see unit test for expected results

export function addLeadingZeros(numDigits: number, num: number = 0): string {
  const numString = (num + 1).toString();
  const numZeros = numDigits - numString.length;
  if (numZeros <= 0) {
    return numString;
  }
  const zeros = "0".repeat(numZeros);
  return zeros + numString;
}

export function scaleNumber(num: number) {
  const result = num * 10 ** 2; // to scale the number
  return result;
}

export function roundNumber(num: number) {
  return Math.round(num);
}

export function roundToTwoDecimals(num: number): number {
  return parseFloat(num.toFixed(2));
}

export function clampFloatingPointErrors(value: number): number {
  const EPSILON = 1e-14;
  
  if (Math.abs(value) < EPSILON) {
    return 0;
  }
  
  if (Math.abs(value - 1) < EPSILON) {
    return 1;
  }
  
  return value;
}